export class PageOption<T>{
    pageSize: number;
    pageNumber: number;
    pageTotal: number = 0;
    orderBy?: number = 0;

    searchFilter: T;
}


// WEBPACK FOOTER //
// ./src/app/models/common/pageOption.ts